import { getPreview } from 'modules/ATS/action.js'

import { connect } from 'react-redux'
import JobPreviewIndex from '..'
import selectors from '../../ATS/selector'
import {
  CloseRole,
  getCandidateMetrics,
  getJobRoleCandidateList,
  getJobRolePreview,
  getPlacementHistoryList,
  getStudentPlacedList,
  getOneRoleExports,
  duplicateRole,
  completeRole,
  getJobRoleCandidateAppliedList
} from '../action'
import selector from '../selector'
import { getExportFiledData, exportCandidate } from '../../JobRoles/actions'

const mapStateToProps = state => ({
  previewData: selectors.getPreviewData(state),
  jobRolePreviewData: selector.getJobRolePreview(state),
  getJobRoleCandidateList: selector.getCandidateListList(state),
  getCandidateMetricsData: selector.getCandidateMetrics(state),
  instituteCampusId: state.auth.instituteDetails.id,
})

const mapDispatchToProps = {
  getPreview,
  getJobRolePreview,
  getJobRoleCandidateList,
  getCandidateMetrics,
  CloseRole,
  getPlacementHistoryList,
  getExportFiledData,
  exportCandidate,
  getStudentPlacedList,
  getOneRoleExports,
  duplicateRole,
  completeRole,
  getJobRoleCandidateAppliedList
}

export default connect(mapStateToProps, mapDispatchToProps)(JobPreviewIndex)
